import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";

const OptionItemExisting = ({
                              language,
                              value,
                              index,
                              onChange,
                              onRemove,
                            }) => {
  const inputRef = useRef(value);

  const handleChange = () => {
    onChange({
      value: inputRef.current.value,
      index,
      language,
    });
  };

  const handleRemove = () => {
    onRemove({
      language,
      index
    });
  };

  return (
    <div className="input-group input-group-sm mb-1">
      <div className="input-group-prepend">
        <span className="input-group-text">#{index + 1}</span>
      </div>
      <input
        ref={inputRef}
        className="form-control form-control-sm"
        type="text"
        defaultValue={value}
      />
      <div className="input-group-append">
        <button className="btn btn-sm btn-outline-success" onClick={handleChange}>
          <FontAwesomeIcon icon={faSave}/>
        </button>
        <button className="btn btn-sm btn-outline-danger" onClick={handleRemove}>
          <FontAwesomeIcon icon={faTimes}/>
        </button>
      </div>
    </div>
  );
};

export default OptionItemExisting;



// WEBPACK FOOTER //
// ./src/views/pages/stories/OptionItemExisting.js